// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Newsletter_componentWrapper__Looj5","newsletterTop":"Newsletter_newsletterTop__Rlv3V","text":"Newsletter_text__S9NB5","newsletter":"Newsletter_newsletter__-i0Dk"};